import Vue from 'vue';
import App from './App';
import '@/utils/rem.js'

import { PiniaVuePlugin } from "pinia";
Vue.use(PiniaVuePlugin)

import * as filters from './filters' // global filters
import pinia from "./store/index";

import { router } from './router';
import { Col, Row, Button, Dialog, ActionSheet, Field, Form, Search, DropdownMenu, DropdownItem, PullRefresh, SwipeCell, Empty } from 'vant';
import { Cell, CellGroup, DatetimePicker, Popup, List, Tab, Tabs, Divider, Collapse, CollapseItem, Image as VanImage, Uploader, Overlay } from 'vant';
import { RadioGroup, Radio, Checkbox, CheckboxGroup, Icon, Switch, Stepper, CountDown, Tabbar, TabbarItem } from 'vant';

Vue.use(Button);
Vue.use(Overlay);
Vue.use(Col);
Vue.use(Row);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Field);
Vue.use(Search);
Vue.use(ActionSheet);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(VanImage);
Vue.use(SwipeCell);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Icon);
Vue.use(Switch);
Vue.use(Stepper);
Vue.use(CountDown);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(router);
Vue.use(Empty);
Vue.use(Uploader);

// 忽略微信开放标签，避免 Vue 报 Unknown custom element 警告
Vue.config.ignoredElements = [/^wx-/];

// 设置全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  pinia,
  router,
  el: '#app',
  render: h => h(App)
});
